import { HorizontalGrip } from '@/frontend/SVGs/HorizontalGrip';
import React, { useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';

export function OrderModal<T extends { id: string, position: number, title: string }>(props: { handleClose: (items: T[]) => void, reorderItems: T[], title: string, setShowOrderModal: (show: boolean) => void }) {
  const { handleClose, reorderItems, setShowOrderModal, title } = props;

  const [items, setItems] = useState(reorderItems.sort(sortByPosition));

  const handleCloseWrapper = () => {
    handleClose(items);
    setShowOrderModal(false);
  };
  const dragItem = useRef<{ theDragObject: T, originalPosition: number } | undefined>(undefined);
  const dragOverItem = useRef<number | undefined>(undefined);

  const dragStart = (
    e: React.DragEvent<HTMLDivElement>,
    startItem: T,
    originalPosition: number
  ) => {
    dragItem.current = { theDragObject: startItem, originalPosition };
  };

  const dragEnd = () => {
    if (dragItem.current !== undefined && dragOverItem.current !== undefined) {
      dragItem.current.theDragObject.position = dragOverItem.current;

      const newList = [...items];
      newList.forEach((sec) => {
        if (dragItem.current!.theDragObject.position > dragItem.current!.originalPosition && dragItem.current!.originalPosition < sec.position && sec.position <= dragItem.current!.theDragObject.position && sec.id !== dragItem.current!.theDragObject.id) {
          sec.position -= 1;
        } else if (dragItem.current!.theDragObject.position < dragItem.current!.originalPosition && dragItem.current!.originalPosition > sec.position && sec.position >= dragItem.current!.theDragObject.position && sec.id !== dragItem.current!.theDragObject.id) {
          sec.position += 1;
        } else if (dragItem.current!.theDragObject.id === sec.id) {
          sec.position = dragItem.current!.theDragObject.position;
        }
    });
      newList.sort(sortByPosition);
      setItems(newList);
    }

    dragItem.current = undefined;
    dragOverItem.current = undefined;
  };

  const dragOver = (e: React.DragEvent<HTMLDivElement>, position: number) => {
    e.preventDefault();
    dragOverItem.current = position;
  };

  function sortByPosition(a: T, b: T) {
    return a.position - b.position;
  }

  return ( <Modal show onHide={handleCloseWrapper}>
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <ul>
          {items.map((reorderItem, index) => {
            return (
              <li key={`${reorderItem.id}-${reorderItem.position}`} className='row border col-11'>
                <div className='d-flex align-items-center'
                  onDragStart={(e) => dragStart(e, reorderItem, index)}
                  onDragEnd={dragEnd}
                  onDragOver={(e) => dragOver(e, index)}
                  draggable
                  style={{ cursor: 'grab' }}
                >
                  <div className="btn btn-sm" title="Drag">
                    <HorizontalGrip />
                  </div>
                  <span className='ms-2'>
                    <small>{`${reorderItem.title}`}</small>
                  </span>
                </div>
              </li>
            );
          })}
      </ul>
    </Modal.Body>
  </Modal>);
}
